// extracted by mini-css-extract-plugin
export default {"confirmButton":"LogoutConfirmModal_confirmButton__6uc29"};